(function(){
  'use strict';

  // Senasis mobile nav buvo pakeistas naujuoju menu drawer'iu — handler pašalintas.

  /* ---------- KREPŠELIS (AJAX) ---------- */
  function updateCartCount(count){
    var link = document.querySelector('.cart-link');
    if(!link) return;
    var badge = link.querySelector('.cart-count');
    if(count > 0){
      if(!badge){ badge = document.createElement('span'); badge.className = 'cart-count'; link.appendChild(badge); }
      badge.textContent = count;
    } else if(badge){ badge.parentNode.removeChild(badge); }
  }

  function updateShipTip(cart){
    var tip = document.querySelector('.ship-tip');
    if(!tip) return;
    var en = window.SHOP_LANG==='en', free = 5000, total = cart.total_price || 0;
    if(!cart.item_count){ tip.className='ship-tip'; tip.innerHTML=''; return; }
    if(total >= free){
      tip.className='ship-tip has done';
      tip.innerHTML = en ? 'Free shipping unlocked ✓' : 'Pristatymas nemokamas ✓';
    } else {
      var left = ((free-total)/100).toFixed(2).replace('.', en?'.':',');
      var pct = Math.min(100, Math.round(total/free*100));
      tip.className='ship-tip has';
      tip.innerHTML = (en ? 'Only €'+left+' to free shipping' : 'Iki nemokamo siuntimo: '+left+' €') + '<span class="ship-bar"><span style="width:'+pct+'%"></span></span>';
    }
  }
  function flashShipTip(){
    var tip = document.querySelector('.ship-tip');
    if(!tip || !tip.classList.contains('has')) return;
    tip.classList.add('show');
    clearTimeout(tip._t); tip._t = setTimeout(function(){ tip.classList.remove('show'); }, 5000);
  }

  function refreshCartCount(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){ updateCartCount(cart.item_count); updateShipTip(cart); updateDockCount(cart.item_count); })
      .catch(function(){});
  }

  /* ---------- FLOATING DOCK + DRAWERS ---------- */
  function fmtMoney(c){ var en=window.SHOP_LANG==='en'; var v=(c/100).toFixed(2); return en ? ('€'+v) : (v.replace('.',',')+' €'); }

  function updateDockCount(count){
    var b=document.querySelector('.dock-count'); if(!b) return;
    if(count>0){ b.hidden=false; b.textContent=count; } else { b.hidden=true; }
  }

  function openDrawer(which){
    var ov=document.querySelector('.drawer-overlay');
    var cd=document.querySelector('.cart-drawer');
    var md=document.querySelector('.menu-drawer');
    if(which==='cart'){ if(md) md.classList.remove('open'); if(cd) cd.classList.add('open'); refreshCartDrawer(); }
    else { if(cd) cd.classList.remove('open'); if(md) md.classList.add('open'); }
    if(ov) ov.classList.add('show');
    document.body.classList.add('drawer-lock');
  }
  function closeDrawers(){
    var ds=document.querySelectorAll('.cart-drawer,.menu-drawer');
    for(var i=0;i<ds.length;i++){ ds[i].classList.remove('open'); }
    var ov=document.querySelector('.drawer-overlay'); if(ov) ov.classList.remove('show');
    document.body.classList.remove('drawer-lock');
  }

  function refreshCartDrawer(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(renderCartDrawer).catch(function(){});
  }
  function renderCartDrawer(cart){
    updateCartCount(cart.item_count); updateShipTip(cart); updateDockCount(cart.item_count);
    var body=document.querySelector('.cart-drawer-body');
    var foot=document.querySelector('.cart-drawer-foot');
    if(!body) return;
    var en=window.SHOP_LANG==='en', free=5000, total=cart.total_price||0, pct=Math.min(100,Math.round(total/free*100));
    var prog = total>=free
      ? '<div class="cd-ship done">'+(en?'Free shipping unlocked ✓':'Pristatymas nemokamas ✓')+'</div>'
      : '<div class="cd-ship">'+(en?('Only €'+((free-total)/100).toFixed(2)+' to free shipping'):('Iki nemokamo siuntimo: '+fmtMoney(free-total)))+'<span class="ship-bar"><span style="width:'+pct+'%"></span></span></div>';
    if(!cart.item_count){
      body.innerHTML = '<div class="cd-empty"><p>'+(en?'Your cart is empty.':'Tavo krepšelis tuščias.')+'</p><a href="/collections/all" class="btn btn-primary">'+(en?'To sauces →':'Į padažus →')+'</a></div>';
      if(foot) foot.style.display='none';
      return;
    }
    function compareAtFor(variantId){
      try {
        var el=document.getElementById('astriai-products-data');
        if(!el) return 0;
        var arr=JSON.parse(el.textContent||'[]');
        for(var i=0;i<arr.length;i++){ if(arr[i].variant===variantId && arr[i].compareAt>0) return arr[i].compareAt; }
      } catch(e){}
      return 0;
    }
    function rowHTML(it, inBundle){
      var qtyBlock = inBundle
        ? '<div class="cd-qty-static">×'+it.quantity+'</div>'
        : '<div class="cd-qty"><button type="button" class="cd-chg" data-key="'+it.key+'" data-q="'+(it.quantity-1)+'">−</button><span>'+it.quantity+'</span><button type="button" class="cd-chg" data-key="'+it.key+'" data-q="'+(it.quantity+1)+'">+</button></div>';
      var removeBtn = inBundle
        ? ''
        : '<button type="button" class="cd-chg cd-remove" data-key="'+it.key+'" data-q="0" aria-label="Remove">×</button>';
      var cmp = compareAtFor(it.variant_id);
      var priceBlock = (cmp>it.price)
        ? '<div class="cd-line"><span class="cd-line-was">'+fmtMoney(cmp*it.quantity)+'</span><br>'+fmtMoney(it.final_line_price)+'</div>'
        : '<div class="cd-line">'+fmtMoney(it.final_line_price)+'</div>';
      var propsHtml='';
      if(it.properties){
        for(var pk in it.properties){
          if(pk.charAt(0)==='_'||!it.properties[pk]) continue;
          propsHtml += '<div class="cd-var">'+pk+': '+it.properties[pk]+'</div>';
        }
      }
      return '<div class="cd-row"><a class="cd-thumb" href="'+it.url+'">'+(it.image?'<img src="'+it.image+'" alt="">':'')+'</a>'
        +'<div class="cd-info"><a class="cd-name" href="'+it.url+'">'+it.product_title+'</a>'
        +((it.variant_title && it.variant_title!=='Default Title')?'<div class="cd-var">'+it.variant_title+'</div>':'')
        +propsHtml
        +qtyBlock+'</div>'
        +'<div class="cd-end">'+priceBlock+removeBtn+'</div></div>';
    }
    // Sugrupuojam rinkinio prekes
    var bundles={}, solo=[];
    cart.items.forEach(function(it){
      var r = it.properties && it.properties.Rinkinys;
      if(r){ (bundles[r]=bundles[r]||[]).push(it); } else { solo.push(it); }
    });
    var html = '';
    Object.keys(bundles).forEach(function(bk){
      var items = bundles[bk];
      var total = items.reduce(function(s,it){return s+it.final_line_price;},0);
      var keys = items.map(function(it){return it.key;}).join(',');
      html += '<div class="cd-bundle"><div class="cd-bundle-head"><span>🎁</span><div><strong>'+(en?'Your set':'Tavo rinkinys')+'</strong><div class="cd-bundle-tag">'+bk+'</div></div><button type="button" class="cd-bundle-x js-remove-bundle" data-keys="'+keys+'">×</button></div><div class="cd-bundle-items">';
      items.forEach(function(it){ html += rowHTML(it, true); });
      html += '</div><div class="cd-bundle-foot"><span>'+(en?'Set total':'Iš viso')+':</span> <strong>'+fmtMoney(total)+'</strong></div></div>';
    });
    solo.forEach(function(it){ html += rowHTML(it, false); });
    body.innerHTML = prog + '<div class="cd-items">'+html+'</div>';
    if(foot){ foot.style.display='block'; var st=foot.querySelector('.cd-subtotal strong'); if(st) st.textContent=fmtMoney(cart.total_price); }
  }
  function changeCart(key,qty){
    fetch('/cart/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){ return r.json(); })
      .then(renderCartDrawer).catch(function(){});
  }
  function removeBundle(keysCsv, reloadPage){
    var keys = (keysCsv||'').split(',').filter(Boolean);
    if(!keys.length) return;
    var updates = {};
    keys.forEach(function(k){ updates[k] = 0; });
    fetch('/cart/update.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:updates})})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if(reloadPage) { location.reload(); return; }
        renderCartDrawer(cart);
      }).catch(function(){});
  }

  document.addEventListener('click', function(e){
    var t=e.target;
    if(!t.closest) return;
    if(t.closest('.dock-cart') || t.closest('.cart-link')){ e.preventDefault(); openDrawer('cart'); return; }
    if(t.closest('.dock-menu') || t.closest('.nav-toggle')){ e.preventDefault(); openDrawer('menu'); return; }
    if(t.closest('.drawer-close') || t.classList.contains('drawer-overlay')){ e.preventDefault(); closeDrawers(); return; }
    var chg=t.closest('.cd-chg');
    if(chg){ e.preventDefault(); changeCart(chg.getAttribute('data-key'), parseInt(chg.getAttribute('data-q'),10)); return; }
    var rb=t.closest('.js-remove-bundle');
    if(rb){ e.preventDefault(); removeBundle(rb.getAttribute('data-keys'), !document.querySelector('.cart-drawer.open')); }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawers(); });

  document.addEventListener('DOMContentLoaded', function(){
    // Meniu nuorodų klonas į drawer
    var nav=document.querySelector('.menu-drawer-nav');
    var menu=document.querySelector('.main-menu');
    if(nav && menu){ nav.innerHTML='<ul class="menu-drawer-list">'+menu.innerHTML+'</ul>'; }
    var lp=document.querySelector('.header-tools .lang-picker');
    var slot=document.querySelector('.menu-drawer-lang');
    if(lp && slot){ slot.innerHTML=lp.outerHTML; }
    // Dock pasirodo nuscrollinus
    var dock=document.querySelector('.float-dock');
    if(dock){
      var onScroll=function(){ if(window.scrollY>250) dock.classList.add('visible'); else dock.classList.remove('visible'); };
      window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
    }
  });

  function addToCart(variantId, btn){
    if(!variantId) return;
    var orig = btn ? btn.innerHTML : '';
    if(btn){ btn.disabled = true; btn.innerHTML = (window.SHOP_LANG==='en'?'Adding…':'Pridedama…'); }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function(r){ return r.json().then(function(d){ return { ok: r.ok, data: d }; }); })
    .then(function(res){
      if(!res.ok){ throw res.data; }
      return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); });
    })
    .then(function(cart){
      updateCartCount(cart.item_count);
      updateShipTip(cart); updateDockCount(cart.item_count);
      if(window.fbq) fbq('track','AddToCart',{content_type:'product',value:(cart.total_price||0)/100,currency:cart.currency||'EUR'});
      renderCartDrawer(cart); openDrawer('cart');
      if(btn){
        btn.innerHTML = (window.SHOP_LANG==='en'?'Added ✓':'Pridėta ✓');
        btn.classList.add('added');
        setTimeout(function(){ btn.disabled = false; btn.innerHTML = orig; btn.classList.remove('added'); }, 1600);
      }
    })
    .catch(function(){
      if(btn){ btn.disabled = false; btn.innerHTML = orig; }
      alert((window.SHOP_LANG==='en'?'Couldn’t add to cart. Try again.':'Nepavyko pridėti į krepšelį. Bandyk dar kartą.'));
    });
  }

  // Visiems "Į krepšelį" mygtukams (sąraše, heat-modal, builder)
  document.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('.js-add-to-cart') : null;
    if(btn){ e.preventDefault(); addToCart(btn.getAttribute('data-variant-id'), btn); }
  });

  // Sinchronizuoti skaitiklį užkrovus puslapį
  document.addEventListener('DOMContentLoaded', refreshCartCount);

  /* ---------- AŠTRUMO MODALAS ---------- */
  function getAllProducts() {
    try {
      var el = document.getElementById('astriai-products-data');
      if (!el) return [];
      return JSON.parse(el.textContent || el.innerText || '[]');
    } catch(e) { return []; }
  }

  var HEAT_BY_NAME = {
    1: ['mango', 'pagard'],
    2: ['mango', 'tropic'],
    3: ['mango', 'tropic', 'jalape', 'jalapeno', 'jalapeño'],
    4: ['jalape', 'aliejus'],
    5: ['masala blaze', 'baltojo kiro', 'kas dega'],
    6: ['masala blaze', 'baltojo kiro', 'kas dega', 'masala punch'],
    7: ['ghost ritual', 'habanero'],
    8: ['ghost ritual', 'habanero'],
    9: ['sabotage', 'aštruolis', 'astruolis', 'pain dealer', 'ghost pepper'],
    10: ['green hell', 'reaper']
  };

  function productHeatMatches(product, min, max) {
    var name = (product.title || '').toLowerCase();
    var tags = (product.tags || '').toLowerCase();
    var tagMatch = tags.match(/(?:astrumas|aštrumas|heat|asru)-?(\d+)/);
    if (tagMatch) {
      var heat = parseInt(tagMatch[1], 10);
      return heat >= min && heat <= max;
    }
    for (var h = min; h <= max; h++) {
      var keywords = HEAT_BY_NAME[h] || [];
      for (var i = 0; i < keywords.length; i++) {
        if (name.indexOf(keywords[i]) !== -1) return true;
      }
    }
    return false;
  }

  function renderProducts(matched) {
    if (!matched.length) {
      return (window.SHOP_LANG==='en'?'<div class="heat-modal-empty">No sauces at this level right now. See <a href="/collections/all">all sauces</a>.</div>':'<div class="heat-modal-empty">Šiame lygyje šiuo metu nėra padažų. Pažiūrėk <a href="/collections/all">visus padažus</a>.</div>');
    }
    var html = '';
    matched.forEach(function(p){
      var addBtn = p.variant
        ? '<button type="button" class="add-btn js-add-to-cart" data-variant-id="' + p.variant + '">'+(window.SHOP_LANG==='en'?'Add to cart →':'Į krepšelį →')+'</button>'
        : '<a href="/products/' + p.handle + '" class="add-btn">'+(window.SHOP_LANG==='en'?'View →':'Žiūrėti →')+'</a>';
      html += '<div class="product-card">' +
        '<a href="/products/' + p.handle + '" class="product-card-link">' +
        (p.image ? '<div class="product-img"><img src="' + p.image + '" alt="' + (p.title || '').replace(/"/g,'&quot;') + '" loading="lazy"></div>' : '<div class="product-img"></div>') +
        '<h3 class="product-name">' + p.title + '</h3>' +
        '</a>' +
        '<div class="price">' + p.price + '</div>' +
        addBtn +
        '</div>';
    });
    return html;
  }

  window.AstriaiHeat = {
    open: function(level, min, max, name, desc) {
      var modal = document.getElementById('heat-modal');
      var content = document.getElementById('heat-modal-content');
      if (!modal || !content) return;
      var products = getAllProducts();
      var matched = products.filter(function(p){ return productHeatMatches(p, min, max); });
      content.innerHTML = '<div class="heat-modal-header">' +
        '<div class="kicker" style="font-family:Anton,sans-serif;color:#CC2200;letter-spacing:.2em;font-size:14px;">★ ' + level + ' LYGIS ★</div>' +
        '<h3 style="font-family:Anton,sans-serif;font-size:clamp(32px,5vw,56px);margin:8px 0 0;text-transform:uppercase;">' + name + '</h3>' +
        '<p style="margin-top:8px;color:#555;">' + desc + '</p>' +
        '<div style="margin-top:8px;font-size:13px;color:#888;">Aštrumas ' + min + (max!==min?'–'+max:'') + '/10</div>' +
        '</div>' +
        '<div id="heat-modal-products" class="heat-modal-products">' + renderProducts(matched) + '</div>' +
        '<div style="text-align:center;margin-top:32px;"><a href="/collections/all" class="btn btn-secondary">'+(window.SHOP_LANG==='en'?'Browse all sauces':'Žiūrėti visus padažus')+'</a></div>';
      modal.hidden = false;
      document.body.classList.add('heat-modal-open');
    },
    close: function(){
      var m = document.getElementById('heat-modal');
      if (m) m.hidden = true;
      document.body.classList.remove('heat-modal-open');
    }
  };

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') AstriaiHeat.close();
  });

  /* ---------- JUDGE.ME: lietuviški linksniai ---------- */
  (function(){
    if(window.SHOP_LANG==='en') return;
    function ltWord(n){ var d=n%10, dd=n%100; if(d===1&&dd!==11) return 'atsiliepimas'; if(d>=2&&d<=9&&(dd<11||dd>19)) return 'atsiliepimai'; return 'atsiliepimų'; }
    function run(){
      document.querySelectorAll('.jdgm-prev-badge__text').forEach(function(el){
        var m=(el.textContent||'').match(/(\d+)/);
        if(!m) return;
        var n=parseInt(m[1],10), want=n+' '+ltWord(n);
        if(el.textContent.trim()!==want) el.textContent=want;
      });
    }
    [600,1500,3000,5000].forEach(function(ms){ setTimeout(run, ms); });
  })();

  /* ---------- NEWSLETTER POPUP ---------- */
  (function(){
    var ov = document.getElementById('np-overlay');
    if(!ov) return;
    function open(){ ov.hidden=false; document.body.classList.add('drawer-lock'); try{localStorage.setItem('np_seen','1');}catch(e){} }
    function close(){ ov.hidden=true; document.body.classList.remove('drawer-lock'); }
    var cb=document.getElementById('np-close');
    if(cb) cb.addEventListener('click', close);
    ov.addEventListener('click', function(e){ if(e.target===ov) close(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !ov.hidden) close(); });
    var success=false; try{ success=sessionStorage.getItem('np_open_success')==='1'; }catch(e){}
    if(success){ try{sessionStorage.removeItem('np_open_success');}catch(e){} open(); return; }
    /* reklamos lankytojams ir produkto/krepselio puslapiuose popup nerodomas */
    var paid=/[?&](fbclid|gclid|utm_medium=paid)/i.test(location.search);
    try{ if(paid) sessionStorage.setItem('np_paid','1'); if(sessionStorage.getItem('np_paid')==='1') return; }catch(e){ if(paid) return; }
    if(/\/(products|cart)(\/|$)/.test(location.pathname)) return;
    var seen=false; try{ seen=localStorage.getItem('np_seen')==='1'; }catch(e){}
    if(seen) return;
    var shown=false;
    function trig(){ if(shown) return; shown=true; open(); }
    setTimeout(trig, 12000);
    document.addEventListener('mouseout', function(e){ if(e.clientY<=0) trig(); });
  })();
})();
